

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"24","width":"24"}, rest), [h('path', {"d":"M0 0h24v24H0V0z","fill":"none"}, []), h('path', {"fill":"currentColor","d":"M14 2H6a2 2 0 00-2 2v16c0 1.1.9 2 2 2h12a2 2 0 002-2V8l-6-6zm4 18H6V4h8v4h4v12zm-6-3a2 2 0 01-2-2V9.5c0-.3.2-.5.5-.5s.5.2.5.5V15h2V9.5a2.5 2.5 0 00-5 0V15a4 4 0 108 0v-4h-2v4a2 2 0 01-2 2z"}, [])]);
};

        